import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Spinner, Alert, Table } from 'react-bootstrap';
import { get, put } from '../../helpers/httpClient';
import { toast } from 'react-toastify';

function WebsitesCatalog() {
  const [websites, setWebsites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({ internal_domain: '', title: '', domain: '' });

  const loadWebsites = () => {
    setLoading(true);
    get('websites', (resp) => {
      setWebsites(resp?.websites || resp || []);
    })
      .catch(() => toast.error('Failed to load websites.'))
      .finally(() => setLoading(false));
  };

  const createWebsite = (e) => {
    e.preventDefault();
    if (!form.internal_domain.trim() || !form.title.trim()) {
      toast.error('Domain and title are required');
      return;
    }
    setCreating(true);
    put('websites', form, () => {
      loadWebsites();
      setForm({ internal_domain: '', title: '', domain: '' });
      setShowCreate(false);
    })
      .catch(() => toast.error('Failed to create website.'))
      .finally(() => setCreating(false));
  };

  const profile = (id) => () => {
    window.location.href = `/websites/${id}`;
  };

  useEffect(() => {
    loadWebsites();
  }, []);

  return (
    <Container className="mt-4">
      <Row className="mb-3">
        <Col>
          <h3>Websites</h3>
        </Col>
      </Row>

      <Row>
        <Col>
          <p className="muted-hint mt-1">
            Manage your websites here. Use Profile to configure a site, View to open its public URL,
            and the Add Website button at the bottom to create a new one.
          </p>
        </Col>
      </Row>

      <Row>
        <Col>
          {loading ? (
            <div className="text-center my-4">
              <Spinner animation="border" />
            </div>
          ) : websites.length === 0 ? (
            <Alert variant="info">No websites yet. Click Add below to create your first website.</Alert>
          ) : (
            <div className="clients-table-wrapper">
              <Table responsive bordered hover className="clients-table align-middle">
                <thead>
                  <tr>
                    <th>Domain</th>
                    <th>Title</th>
                    <th className="col-nowrap">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {websites.map((p, idx) => (
                    <tr key={p.id || idx}>
                      <td>{p.domain || p.internal_domain || '-'}</td>
                      <td>{p.title || 'Untitled'}</td>
                      <td className="col-nowrap">
                        <div className="form-actions">
                          <button onClick={profile(p.id)} className="primary-button">Profile</button>
                          {p.domain && (
                            <a
                              className="primary-button"
                              href={`https://${p.domain}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              View
                            </a>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
          )}
        </Col>
      </Row>

      {!showCreate && (
        <Row className="mt-3">
          <Col>
            <Button className="primary-button" onClick={() => setShowCreate(true)}>
              Add Website
            </Button>
          </Col>
        </Row>
      )}

      {showCreate && (
        <Row className="mt-3">
          <Col md={8} lg={6}>
            <Card>
              <Card.Body>
                <Card.Title>Create Website</Card.Title>
                <Form onSubmit={createWebsite}>
                  <Form.Group className="mb-3 form-row-horizontal" controlId="websiteInternalDomain">
                    <Form.Label>Website's Address</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="e.g. project-123"
                      value={form.internal_domain}
                      onChange={(e) => setForm({ ...form, internal_domain: e.target.value })}
                    />
                  </Form.Group>
                  <Form.Group className="mb-3 form-row-horizontal" controlId="websiteTitle">
                    <Form.Label>Website's Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Marketing site"
                      value={form.title}
                      onChange={(e) => setForm({ ...form, title: e.target.value })}
                    />
                  </Form.Group>
                  <div className="form-actions">
                    <Button className="primary-button" onClick={() => setShowCreate(false)}>
                      Cancel
                    </Button>
                    <Button type="submit" className="primary-button" disabled={creating}>
                      {creating ? (
                        <><Spinner animation="border" size="sm" className="me-2" />Creating...</>
                      ) : 'Create'}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}
    </Container>
  );
}

export default WebsitesCatalog;
